import React,{Fragment, useEffect} from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
// import LoginRegister from "../components/LoginRegister";
import MobileMenu from "../components/MobileMenu";
import AboutChart from '../components/AboutChart';
import ToolBarMenu from "../components/ToolBarMenu";
import {useAboutUs} from "../queries/aboutUs";
import AboutUsDetails from "../templates/AboutUsDetails";
import { useParams } from 'react-router-dom';
import ServiceThumb from '../assets/img/about.jpg'

const PageAbout = () => {
    const a = useParams(); 
    
    return (
        <Fragment>
             {/* <ToolBarMenu/> */} 
            <Header/>
            
            <AboutUsDetails aboutId={a.id}/>
            <Footer/>
            {/* <LoginRegister/> */}
            <MobileMenu isSided={true}/>
        </Fragment>
    );
};

export default PageAbout;
